import React, { Children, useEffect, useRef, useState } from "react";
import Oval from "react-loading-icons/dist/esm/components/oval";
import { useDispatch, useSelector } from "react-redux";
import { ChangeoutputPinState } from "../../../../../../store/service-actions"
import Card from "../../../../Cards/Card";
import { socket } from "../../../../../../Socket/socket";
import useSocketManager from "../../../../../../Socket/useSocketManager";
import classes from "./PinOutput.module.css";
import InactiveIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/Pin/default - Off.svg";
import HiddenIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/HiddenPin.svg";
import pulseIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/Pin/__Switch - Pulse.png";
import LockIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/lock_icon.png"
import managerOnly from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/PinIcon-Manager/crown_grey.png"
import adminOnly from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/PinIcon-Manager/crown.png"

import { GenerateLockOTPAPI, switchLatch } from "../../../../../../Api Methods/Api";
import Battery from "../../../../../Battery/Battery";
import UseDateFormat from "../../../../../hooks/UseDateFormat";
import UseParseYearMonthDate from "../../../../../hooks/UseParseYearMonthDate";
import DataManager from "../../../../../../hooks/DataManager";
import Modal from "../../../../../Modal/Modal";
import GenerateLockOnTimePassCodeForm from "../../../../Cards/Automations/EditAutomations/GenerateLockOnTimePassCodeForm";
import ShowOTPPopup from "../../../../Cards/Automations/VirutalSources/SmartLocks/ShowOTPPopup";
import Lottie from 'lottie-react'
import failAnim from '../../../../../../assets/animations/fail.json'
import Button1 from "../../../../Button/Button1";
import yellowWarn from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/yellow_warn.png'
import amberWarn from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/amber_warn.png'
import redWarn from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/red_warn.png'
import { Button } from "primereact/button";
import HolidayModeWarningDialog from "./HolidayModeWarningDialog";

const PinOutput = ({ OutPutPin, polarity, SmartLock, firmware, holidayModeActive, linkedIntegrationIcon }) => {
    const dispatch = useDispatch();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const userID = useSelector(state => state.auth.userID);

    const { pinName, pinStatusOff, pinStatusOn, pinState, icon, accessLevel, DeviceUUID, Pin, active, type, DeviceType, missedPolls } = OutPutPin;
    const actionOneOnLabel = OutPutPin.actionOneOnLabel || "disarm";
    const actionOneOffLabel = OutPutPin.actionOneOffLabel || "arm";
    console.log(icon);
    const lowerCaseStringIcon = icon?.toLowerCase();
    const image = lowerCaseStringIcon + " - Off";
    const otherStateImage = icon + " - On";
    const staticPath = "/assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/";
    const isManagerOnly = accessLevel === "manager" ? true : false
    const isAdminOnly = accessLevel === "admin" ? true : false
    const imageFromPath = `${process.env.PUBLIC_URL}${staticPath}${image}.png`
    console.log(imageFromPath);
    let otherStateImageFromPath = `${process.env.PUBLIC_URL}${staticPath}${otherStateImage}.png`;

    console.log(imageFromPath);
    console.log(otherStateImageFromPath);

    const initialPinState = polarity === 1 ? pinState : !pinState;

    const [PinState, setPinState] = useState();
    const [pinStateLoading, setPinStateLoading] = useState(false);
    const [buttonClicked, setButtonClicked] = useState(false);

    const POLL_INTERVAL_MINUTES = 10;

    const offlineMs = missedPolls * POLL_INTERVAL_MINUTES * 60 * 1000;
    const offlineSinceDate = new Date(Date.now() - offlineMs).toLocaleDateString()
    
    const ModalDialog = useRef();
    const [title, setTitle] = useState("Generate passcode")
    const [modalComponent, setModalComponent] = useState();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
    };

    const apiData = {
        token,
        client,
    }


    useEffect(() => {
        setPinStateLoading(false)
        setButtonClicked(false)
    }, [OutPutPin])

    useEffect(() => {
        //if external source updates the state, update PinState to reflect that
        setPinState(initialPinState);
    }, [initialPinState]);

    useEffect(() => {
        setPinStateLoading(false);
        setButtonClicked(false);
    }, [pinState])

    const GenerateOTP = async (otpName, startDate, endDate, type, lockID) => {
        const body = {
            lockID: lockID,
            startDate: startDate,
            endDate: endDate,
            type: type,
            uuid: DeviceUUID,
            otpName: otpName,
        }

        const responseData = await GenerateLockOTPAPI(apiData, body, dispatch)
        if (responseData && responseData.success) {
            HandleCloseModal();
            setTitle("Lock access code")
            setModalComponent(
                <ShowOTPPopup pincode={responseData.data.pin} closeModal={HandleCloseModal} />
            )
            HandleShowModal();
        } else {
            //error modal
            HandleCloseModal();
            setTitle("Error")
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie animationData={failAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
                    <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{"Failed to generate pincode"}</h3>
                    <p style={{ textAlign: "center", color: "#6e6e6eff" }}>{"Please note, you can only generate up to 5 pincodes per hour"}</p>
                    <br></br>
          <Button onClick={HandleCloseModal} label="Close" severity='secondary'/>
                </div>
            )

            HandleShowModal();
        }
    }


    const [showHolidayWarning, setShowHolidayWarning] = useState(false);

    const performPinClick = async (smartLock) => {
        if (smartLock == null) {
            setPinStateLoading(true);
            setButtonClicked(true);

            let body = {};
            const firmwareMajor = firmware.split('.')[0];
            const firmwareMinor = firmware.split('.')[1];

            if (socket.connected) {
                if (firmwareMajor > 1 || (firmwareMajor == 1 && firmwareMinor >= 7)) {
                    body["cmd"] = "setVirtualState"
                } else {
                    body["cmd"] = "setState"
                }

                body["allPins"] = "no";
                body["uuid"] = DeviceUUID;
                body["pin"] = Pin;
                body["state"] = !PinState;
                body["user"] = userID;
                body["eventID"] = crypto.randomUUID();
                socket.emit("routeCommand", body);
            } else {
                const response = await switchLatch(apiData, userID, Pin, !PinState, DeviceUUID, type, DeviceType, dispatch)
                if (response) {
                    setPinState(!PinState);
                    setPinStateLoading(false);
                    setButtonClicked(false);
                } else {
                    setPinState(PinState);
                    setButtonClicked(false);
                }
            }
        } else {

            setModalComponent(
                <GenerateLockOnTimePassCodeForm SmartLock={smartLock} GenerateOTP={GenerateOTP} />
            )
            HandleShowModal()
        }
    }

    const HandlePinClick = (smartLock) => {
        if (smartLock == null && holidayModeActive) {
            setShowHolidayWarning(true);
        } else {
            performPinClick(smartLock);
        }
    }

    const HandleConfirmHolidayWarning = () => {
        setShowHolidayWarning(false);
        performPinClick(null);
    }

    let LockReadDate;
    if (SmartLock != null) {
        const batteryReadAt = SmartLock && SmartLock.batteryReadAt
        LockReadDate = UseParseYearMonthDate(batteryReadAt);
    }

    const createPasscode = () => {
    }

    const getDeviceStatus = (missedPolls) => {
        if (missedPolls === 1) return "Connectivity issue detected";
        if (missedPolls === 2) return "Frequent connection issues";
        if (missedPolls >= 3) return "Device offline or unresponsive";
        return "Device stable";
    };

    return (
        <>
            <Modal ref={ModalDialog} title={title} modalName={""} HandleShowModal={HandleShowModal}>
                {modalComponent}
            </Modal>

            <HolidayModeWarningDialog
                visible={showHolidayWarning}
                onConfirm={HandleConfirmHolidayWarning}
                onCancel={() => setShowHolidayWarning(false)}
            />

            <button className={`${classes["pin-switch"]} ${!active && classes["disabled-hover"]}`} style={{ opacity: !active && "50%", backgroundColor: SmartLock != null && "var(--PinLockColor)" }} disabled={buttonClicked} onClick={() => HandlePinClick(SmartLock)}>
                {buttonClicked && SmartLock == null && (
                    <div className={classes.overlay} style={{ backgroundColor: "rgba(0,0,0,0.45)", pointerEvents: "none" }}>
                        <Oval stroke="white" strokeWidth={3} width={36} height={36} />
                    </div>
                )}
                <div className={classes.top}>
                    {SmartLock == null ?
                    <>
                        <h3 className={classes.pinName} style={{color:"#737373", fontWeight:"450", marginBottom:"5px"}}>{pinName}</h3>
                        
                        <div className={classes.topRightIconGroup}>
                            {isManagerOnly && <img className={classes.imgManager} src={managerOnly} />}
                            {isAdminOnly && <img className={classes.imgManager2} src={adminOnly} />}
                            { missedPolls > 0 ?
                        <>
                        <img
                            src={missedPolls == 1 ? yellowWarn : missedPolls == 2 ? amberWarn : missedPolls >= 3 ? redWarn : ""}
                            className={classes.pinIconTopRight}
                            alt="Warning"
                            title={getDeviceStatus(missedPolls)}
                        />
                        <p className={classes.warningIconText} style={{color:"#6e6e6e", fontSize:"9px", alignContent:"flex-end", fontWeight:500}}>{offlineSinceDate}</p>
                        </> 
                        : 
                         <img className={classes.pinIconTopRight} src={active ? PinState ? imageFromPath : otherStateImageFromPath : InactiveIcon} />
                        }

                        </div>

                        {linkedIntegrationIcon && (
                            <img
                                src={linkedIntegrationIcon}
                                alt="Linked integration"
                                title="Linked to an integration"
                                style={{ position: "absolute", top: "40px", right: "8px", width: "22px", height: "22px", objectFit: "contain" }}
                            />
                        )}
                    </>
                        :
                        <>
                            <h3 className={classes.pinName} style={{color:"#ffffff", fontWeight:"450", marginBottom:"5px"}}>{pinName}</h3>
                            <div className={classes.topRightIconGroup}>
                                {isManagerOnly && <img className={classes.imgManager} style={{filter: "brightness(0) invert(1)"}} src={managerOnly} />}
                                {isAdminOnly && <img className={classes.imgManager2} style={{filter: "brightness(0) invert(0)"}} src={adminOnly} />}

                                <img className={classes.pinIconTopRight} src={LockIcon} />
                            </div>
                        </>
                    }


                    {SmartLock == null ?
                    <>
                        <h3 className={!pinStateLoading ? active ? PinState ? classes.On : classes.Off : classes.inactive : classes.loading}>
                            {buttonClicked ? "Please wait..." : active ? PinState ? pinStatusOff : pinStatusOn : "Inactive"}
                        </h3>
                        {!buttonClicked && active && (
                            <p className={classes.clickToText}>
                                Click to {PinState ? actionOneOffLabel : actionOneOnLabel}
                            </p>
                        )}
                    </>
                    :
                    <>
                        <div className={classes.lockBatteryRow}>
                            <Battery BatteryPowerLevel={SmartLock.battery} isActive={active} />
                            <h2 className={classes["battery-percentage"]}>{SmartLock.battery + "%"}</h2>
                            <h2 className={classes.lockDate}>{LockReadDate}</h2>
                        </div>
                        <p className={classes.clickToText} style={{color: "#ffffff"}}>Click to generate passcode</p>
                    </>
                    }
                </div>

                <div className={classes.bottom} />
            </button>
        </>
    );
}

export default PinOutput;